import React from 'react';
import styled from '@emotion/styled';

import { CategoryTypeString } from '@diritto/common/content/constants';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';

import { getTextLineStyle } from 'styles/common';
import { DotDivider } from 'ui-components/common/DotDivider';
import { Link } from 'ui-components/common/Link';
import { IconCount, IconCountType } from 'ui-components/contents/IconCount';
import { ContentBadgeGroup } from 'ui-components/contents/ContentBadgeGroup';
import { ContentCover } from 'ui-components/contents/ContentCover';
import { ProfileName } from 'app-components/contents/ProfileName';

interface SectionContentLiteItemProps {
  content: ContentPublicRelayDto;
  profile: ProfileLitePublicRelayDto;
  showCategory?: boolean;
  onClick?: () => void;
}

const Height = 262;
const CoverImageWidth = 110;

export const SectionContentLiteItem = ({
  content,
  profile,
  showCategory = true,
  onClick,
}: SectionContentLiteItemProps) => (
  <StyledContentWrapper onClick={onClick}>
    <Link href={`/contents/${content.id}`}>
      <ContentCover content={content} size={CoverImageWidth}>
        <ContentBadgeGroup content={content} />
      </ContentCover>
    </Link>
    <StyledContentMetaContainer>
      <Link href={`/contents/${content.id}`}>
        <StyledTitle>{content.title}</StyledTitle>
      </Link>
      <StyledMeta>
        <ProfileName profile={profile} />{' '}
        {showCategory ? (
          <>
            <DotDivider />
            <div>{CategoryTypeString[content.categoryType]}</div>
          </>
        ) : null}
      </StyledMeta>
      <StyledMeta>
        <IconCount count={content.counts.viewCount || 0} type={IconCountType.View} />
      </StyledMeta>
    </StyledContentMetaContainer>
  </StyledContentWrapper>
);

const StyledContentWrapper = styled.div`
  width: 110px;
  height: ${Height}px;
`;

const StyledContentMetaContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 4px;
`;

const StyledTitle = styled.p`
  font-weight: ${FontWeight.Bold};
  ${Typography.XXSmall};
  ${getTextLineStyle(2)};
`;

const StyledMeta = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-weight: ${FontWeight.Medium};
  ${Typography.XXXSmall};
  color: ${Color.Gray600};
`;
